import React, { useCallback, useEffect, useState } from "react";

// controllers
import { EmployeeController } from "controllers";

import { EmployeeCard } from "./employee-card";
import { Hero } from "shared/components/bulma/hero";
import { AddEmployee } from "./add-employee";

import { useStore } from "react-redux";
import { sortArrayPipe } from "shared/pipes";
import { deleteEmployeeById } from "controllers/Employee";

const Employees = () => {
    const store = useStore();
    const { countries } = store.getState();
    const country = countries.value;

    const [employees, setEmployees] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);

    const getEmployees = useCallback(async () => {
        const e = await EmployeeController.getEmployees(country);
        setEmployees(sortArrayPipe.transform(e, 'first_name'));
    }, [country]);
    const handleAdd = (employee) => {
        getEmployees()
    }
    const HandleDelete = (id) => {
        if (id) {
            deleteEmployeeById(id,setEmployees,isDeleting, setIsDeleting)
        } else {
            
        }
    }
    useEffect(() => {
      

        getEmployees();
    }, [getEmployees]);
    return (
        <>
            <Hero className="is-small is-light">
                <div className="columns">
                    <div className="column is-offset-10">
                        <AddEmployee onAdd={handleAdd} />
                    </div>
                </div>
            </Hero>

            <Hero>
                <div className="columns is-multiline">
                    {employees.map((employee) => (
                        <div key={employee.id} className="column is-3">
                            <EmployeeCard employee={employee} HandleDelete={HandleDelete} />
                        </div>
                    ))}
                </div>
            </Hero>
        </>
    );
}

export { Employees };
